import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)


// import Comingsoon from '@/components/secondlevel'


const routes = [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: Home
    // },

    {
        path: '/AppointmentExamineDetails',
        name: 'app',

        title:"待审批详情",
        component: resolve => require(['@/components/AppointmentExamineDetails.vue'], resolve),
        // component: () => import(/* webpackChunkName: "home" */ '../components/Visualization.vue'),
        // require(['@/views/Main'],resolve)
        //   component: () => import(/* webpackChunkName: "home" */ '@/views/Main.vue'),
        meta: {
            title: '海鸥住工'
        },

    },

    {
        path: '/MaterialAppointmentExamineDetails',
        name: 'app',
        title:"外来物质跟踪卡",
        component: resolve => require(['@/components/MaterialAppointmentExamineDetail.vue'], resolve),
        // component: () => import(/* webpackChunkName: "home" */ '../components/Visualization.vue'),
        // require(['@/views/Main'],resolve)
        //   component: () => import(/* webpackChunkName: "home" */ '@/views/Main.vue'),
        meta: {
            title: '海鸥住工'
        },

    }






]

const router = new VueRouter({

    mode: 'history',
    // mode: "hash",//此处如果是history，需要修改为hash
    base: process.env.BASE_URL,
    // base:"dist",
    routes
})

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }


router.beforeEach((to, from, next) => {

    // console.log("路由：beforeEach")
    // console.log("路由to:" + JSON.stringify(to))
    // console.log("路由from:", from)
    // console.log("路由next:", JSON.stringify(next))
    // console.log("离开的路由" + from.path)


    //
    // if (to.path == '/distTest/'&&from.path=="/WorkReportDetails") {//必要的
    //
    //
    //
    //     if (window.__wxjs_environment === 'miniprogram') {//小程序环境
    //         console.log("小程序环境")
    //
    //         //微信jssdk 返回小程序
    //         wx.miniProgram.navigateBack({url: '/insider/WorkReport/WorkReportList/WorkReportList'});
    //         wx.closeWindow();
    //
    //     } else {
    //         wx.closeWindow();
    //         // this.#$router.go(-3)
    //     }
    //
    // } else {
    //     next()
    // }


    next()


    // 这样当从一个普通页面A进入待监听组件时，在待监听组件中按返回键时能正常进入A
})

export default router
